import { Layered } from './group-settings'

// The layers of `dependent` (undefined for the group's) that the portals a save of `source` reaches read, where
// `matches` holds: a portal's own or inherited one, or for a group save, the group's and its followers' overrides.
export function dependentLayers<S, D>(
  source: Layered<S>,
  dependent: Layered<D>,
  stores: string[],
  ecommerceId: string | undefined,
  matches: (value: D) => boolean
): (string | undefined)[] {
  if (ecommerceId) {
    const value = dependent.overrides[ecommerceId] ?? dependent.group
    return value && matches(value) ? [ecommerceId] : []
  }
  const followers = stores.filter((store) => !source.overrides[store])
  const group =
    dependent.group &&
    matches(dependent.group) &&
    followers.some((store) => !dependent.overrides[store])
      ? [undefined]
      : []
  return [
    ...group,
    ...followers.filter((store) => {
      const value = dependent.overrides[store]
      return value !== undefined && matches(value)
    })
  ]
}
